export const translations = {
  en: {
    // App
    'app.name': 'KiranaFlow',
    'app.tagline': 'Simple. Fast. Powerful.',
    'app.loading': 'Loading...',

    // Common
    'common.search': 'Search',
    'common.add': 'Add',
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.logout': 'Logout',
    'common.edit': 'Edit',
    'common.delete': 'Delete',
    'common.close': 'Close',
    'common.update': 'Update',
    'common.submit': 'Submit',
    'common.confirm': 'Confirm',
    'common.yes': 'Yes',
    'common.no': 'No',
    'common.loading': 'Loading...',
    'common.processing': 'Processing...',
    'common.sending': 'Sending...',
    'common.sent': 'Sent!',
    'common.all': 'All',
    'common.items': 'items',
    'common.stock': 'Stock',
    'common.price': 'Price',
    'common.gst': 'GST',
    'common.total': 'Total',
    'common.subtotal': 'Subtotal',
    'common.amount': 'Amount',
    'common.date': 'Date',
    'common.name': 'Name',
    'common.mobile': 'Mobile',
    'common.address': 'Address',
    'common.actions': 'Actions',
    'common.status': 'Status',
    'common.from': 'From',
    'common.to': 'To',
    'common.no_data': 'No data found',
    'common.days_left': 'd left',
    'common.expired': 'Expired',
    'common.low': 'Low',
    'common.in_stock': 'in stock',
    'common.customers': 'Customers',
    'common.products': 'Products',
    'common.revenue': 'Revenue',

    // Auth
    'auth.login': 'Login',
    'auth.mobile': 'Mobile Number',
    'auth.password': 'Password',
    'auth.demo_creds': 'Demo Credentials:',
    'auth.admin_creds': 'Admin: 9876543210 / demo123',
    'auth.employee_creds': 'Employee: 9876543220 / emp123',
    'auth.logging_in': 'Logging in...',

    // Language
    'lang.switch_to_mr': 'Switch to मराठी',
    'lang.switch_to_hi': 'Switch to हिंदी',
    'lang.switch_to_en': 'Switch to English',
    'lang.english': 'English',
    'lang.marathi': 'मराठी',
    'lang.hindi': 'हिंदी',
    'lang.kannada': 'ಕನ್ನಡ',

    // Nav section labels
    'nav.dashboard': 'Dashboard',
    'nav.billing': 'Billing',
    'nav.stock': 'Stock',
    'nav.purchase': 'Purchase',
    'nav.settings': 'Settings',

    // Dashboard — Today's Actions
    'dashboard.title':           "Today's Actions",
    'dashboard.reorder_alerts':  'Reorder Alerts',
    'dashboard.dead_stock':      'Dead Stock',
    'dashboard.expiry_risks':    'Expiry Risks',
    'dashboard.daily_snapshot':  'Daily Snapshot',
    'dashboard.days_remaining':  'days remaining',
    'dashboard.reorder_qty':     'Order Qty',
    'dashboard.holding_cost':    'Capital Blocked',
    'dashboard.call_supplier':   'Call Supplier',
    'dashboard.no_reorder_needed': 'All stock levels are healthy',
    'dashboard.no_dead_stock':   'No dead stock found',
    'dashboard.no_expiry_risk':  'No expiry risks',

    // Navigation / Module Titles
    'dashboard.title': 'Dashboard',
    'pos.title': 'Point of Sale',
    'products.title': 'Products',
    'suppliers.title': 'Suppliers',
    'po.title': 'Purchase Orders',
    'grn.title': 'Goods Received',
    'customers.title': 'Customers',
    'stores.title': 'Stores',
    'employees.title': 'Employees',
    'reports.title': 'Reports',
    'advanced_reports.title': 'Advanced Reports',

    // Dashboard
    'dashboard.welcome': "Welcome back! Here's what's happening today.",
    'dashboard.today_revenue': "Today's Revenue",
    'dashboard.transactions': 'Transactions',
    'dashboard.pending_khata': 'Pending Khata',
    'dashboard.low_stock': 'Low Stock',
    'dashboard.items_restock': 'items need restock',
    'dashboard.sales_this_week': 'Sales This Week',
    'dashboard.expiry_alerts': 'Expiry Alerts',
    'dashboard.no_expiry': 'No products expiring soon!',
    'dashboard.low_stock_alert': 'Low Stock Alert',
    'dashboard.all_stocked': 'All products are well stocked!',
    'dashboard.pending_khata_title': 'Pending Khata',
    'dashboard.no_khata': 'No pending khata payments!',
    'dashboard.ai_insights': 'AI Business Insights',
    'dashboard.ai_analyzing': 'Analyzing your business data...',
    'dashboard.ai_no_insights': 'No insights available. Add more products and sales data to get recommendations.',
    'dashboard.quick_actions': 'Quick Actions',
    'dashboard.new_sale': 'New Sale',
    'dashboard.add_product': 'Add Product',
    'dashboard.add_customer': 'Add Customer',
    'dashboard.view_reports': 'View Reports',

    // POS
    'pos.search_product': 'Search by name or scan barcode...',
    'pos.cart': 'Cart',
    'pos.total': 'Total',
    'pos.pay': 'Pay',
    'pos.cash': 'Cash',
    'pos.card': 'Card',
    'pos.upi': 'UPI',
    'pos.khata': 'Khata/Credit',
    'pos.cart_empty': 'Cart is empty',
    'pos.clear_cart': 'Clear Cart',
    'pos.select_customer': 'Select customer',
    'pos.customer_label': 'Customer (Optional / Required for Khata)',
    'pos.no_products': 'No products found. Try a different search term.',
    'pos.barcode_active': 'Barcode Scanner Active',
    'pos.select_payment': 'Select Payment Mode',
    'pos.confirm_payment': 'Confirm Payment',
    'pos.khata_customer': 'Customer:',
    'pos.current_balance': 'Current Balance:',
    'pos.new_balance': 'New Balance:',
    'pos.err_cart_empty': 'Cart is empty',
    'pos.err_khata_customer': 'Please select a customer for Khata payment',
    'pos.err_no_stock': 'Not enough stock available',
    'pos.err_out_of_stock': 'Out of stock',
    'pos.err_not_enough': 'Not enough stock',
    'pos.err_load_products': 'Failed to load products',
    'pos.err_barcode_not_found': 'Barcode not found in inventory',
    'pos.payment_failed': 'Payment failed',
    'pos.sale_complete': 'Sale complete! Invoice:',
    'pos.mock_upi': 'Using mock UPI payment (add Razorpay keys for real payments)',
    'pos.items': 'items',
    'pos.subtotal': 'Subtotal',
    'pos.gst': 'GST',

    // Products
    'products.add_product': 'Add Product',
    'products.edit_product': 'Edit Product',
    'products.add_new': 'Add New Product',
    'products.update': 'Update Product',
    'products.in_inventory': 'products in inventory',
    'products.search_placeholder': 'Search products by name, category, or barcode...',
    'products.no_found': 'No products found',
    'products.delete_confirm': 'Are you sure you want to delete this product?',
    'products.added': 'Product added successfully',
    'products.updated': 'Product updated successfully',
    'products.deleted': 'Product deleted successfully',
    'products.err_load': 'Failed to load products',
    'products.err_save': 'Failed to save product',
    'products.err_delete': 'Failed to delete product',
    'products.scan_barcode': 'Scan Barcode',
    'products.scanning': 'Scanning...',
    'products.scanner_ready': '📷 Barcode scanner ready! Scan product barcode now...',
    'products.barcode_scanned': '🔍 Barcode scanned:',
    'products.barcode_exists': 'Product already exists with this barcode',
    'products.field_name': 'Product Name *',
    'products.field_name_mr': 'Name (Marathi)',
    'products.field_name_hi': 'Name (Hindi)',
    'products.field_category': 'Category *',
    'products.field_barcode': 'Barcode',
    'products.field_barcode_scanned': 'Barcode (Scanned)',
    'products.field_price': 'Selling Price (₹) *',
    'products.field_cost': 'Cost Price (₹) *',
    'products.field_gst': 'GST Rate (%) *',
    'products.field_stock': 'Current Stock *',
    'products.field_min_stock': 'Minimum Stock *',
    'products.field_unit': 'Unit *',
    'products.field_expiry': 'Expiry Date',
    'products.scan_placeholder': 'Scan barcode...',
    'products.enter_barcode': 'Enter barcode manually',
    'products.cat_placeholder': 'e.g., Groceries, Beverages',
    'products.unit_placeholder': 'piece, kg, liter',
    'products.label_price': 'Price:',
    'products.label_stock': 'Stock:',
    'products.label_gst': 'GST:',
    'products.label_expiry': 'Expiry:',
    'products.label_barcode': 'Barcode:',

    // Customers
    'customers.add': 'Add Customer',
    'customers.edit': 'Edit Customer',
    'customers.search': 'Search customers by name or mobile...',
    'customers.count': 'customers',
    'customers.added': 'Customer added successfully',
    'customers.err_load': 'Failed to load customers',
    'customers.record_payment': 'Record Payment',
    'customers.payment_recorded': 'Payment recorded successfully',
    'customers.field_name': 'Customer Name *',
    'customers.field_mobile': 'Mobile Number *',
    'customers.field_address': 'Address',
    'customers.khata_balance': 'Khata Balance',
    'customers.payment_amount': 'Payment Amount (₹)',
    'customers.no_customers': 'No customers found',
    'customers.total_khata': 'Total Khata:',

    // Suppliers
    'suppliers.add': 'Add Supplier',
    'suppliers.search': 'Search suppliers by name, mobile, or contact...',
    'suppliers.count': 'suppliers',
    'suppliers.added': 'Supplier added successfully',
    'suppliers.err_load': 'Failed to load suppliers',
    'suppliers.err_add': 'Failed to add supplier',
    'suppliers.field_name': 'Supplier Name *',
    'suppliers.field_contact': 'Contact Person',
    'suppliers.field_mobile': 'Mobile Number *',
    'suppliers.field_email': 'Email',
    'suppliers.field_address': 'Address',
    'suppliers.field_gstin': 'GSTIN',
    'suppliers.no_found': 'No suppliers found',

    // Stores
    'stores.add': 'Add Store',
    'stores.count': 'active stores',
    'stores.added': 'Store added successfully',
    'stores.err_load': 'Failed to load stores',
    'stores.err_add': 'Failed to add store',
    'stores.field_name': 'Store Name *',
    'stores.field_address': 'Address',
    'stores.field_manager': 'Manager Name',
    'stores.field_mobile': 'Mobile',
    'stores.no_found': 'No stores found',

    // Employees
    'employees.add': 'Add Employee',
    'employees.tab_employees': 'Employees',
    'employees.tab_attendance': 'Attendance',
    'employees.mark_attendance': 'Mark Attendance',
    'employees.added': 'Employee added successfully',
    'employees.attendance_marked': 'Attendance marked successfully',
    'employees.err_load': 'Failed to load data',
    'employees.field_name': 'Employee Name *',
    'employees.field_mobile': 'Mobile Number *',
    'employees.field_role': 'Role',
    'employees.field_salary': 'Salary (₹)',
    'employees.no_found': 'No employees found',

    // GRN
    'grn.add': 'Add GRN',
    'grn.err_load': 'Failed to load data',
    'grn.select_po': 'Select PO',
    'grn.expiry_scanned': 'Expiry date scanned:',
    'grn.expiry_parse_err': 'Could not parse expiry date from barcode',

    // Purchase Orders
    'po.add': 'Add Purchase Order',
    'po.created': 'Purchase order created successfully',
    'po.err_supplier': 'Please select a supplier',
    'po.err_items': 'Please add at least one item',
    'po.err_duplicate': 'Product already in order',
    'po.select_supplier': 'Select supplier',

    // Reports
    'reports.subtitle': 'View sales and GST reports',
    'reports.loading': 'Loading reports...',
    'reports.sales': 'Sales Report',
    'reports.gst': 'GST Report',
    'reports.today': 'Today',
    'reports.week': 'This Week',
    'reports.month': 'This Month',
    'reports.year': 'This Year',
    'reports.taxable': 'Taxable Value',
    'reports.tax_amount': 'Tax Amount',
    'reports.qty_sold': 'Qty Sold',

    // Advanced Reports
    'advanced_reports.subtitle': 'Comprehensive business analytics and reports',
    'advanced_reports.pl': 'Profit & Loss',
    'advanced_reports.multi_store': 'Multi-Store',
    'advanced_reports.gst': 'GST',
    'advanced_reports.expenses': 'Expenses',
    'advanced_reports.payments': 'Payments',
    'advanced_reports.top_selling': 'Top Selling',
    'advanced_reports.dead_stock': 'Dead Stock',
    'advanced_reports.add_expense': 'Add Expense',
    'advanced_reports.add_payment': 'Add Vendor Payment',
    'advanced_reports.no_stores': 'No stores configured yet. Add stores from the Stores page.',

    // Receipt
    'receipt.title': 'Bill Receipt',
    'receipt.invoice': 'Invoice',
    'receipt.customer': 'Customer',
    'receipt.item': 'ITEM',
    'receipt.qty': 'QTY',
    'receipt.rate': 'RATE',
    'receipt.amount': 'AMOUNT',
    'receipt.items': 'Items:',
    'receipt.qty_label': 'Qty:',
    'receipt.subtotal': 'Subtotal (excl. GST)',
    'receipt.total_gst': 'Total GST',
    'receipt.total': 'TOTAL',
    'receipt.payment_mode': 'Payment Mode',
    'receipt.tax_summary': 'TAX SUMMARY',
    'receipt.rate_col': 'Rate',
    'receipt.taxable': 'Taxable',
    'receipt.cgst': 'CGST',
    'receipt.sgst': 'SGST',
    'receipt.thank_you': '** THANK YOU FOR SHOPPING **',
    'receipt.visit_again': 'Please visit us again!',
    'receipt.computer_generated': 'This is a computer generated receipt',
    'receipt.no_return': 'Goods once sold will not be taken back',
    'receipt.print_pdf': 'Print / Save PDF',
    'receipt.send_whatsapp': 'Send WhatsApp',
    'receipt.whatsapp_no_customer': 'Select a customer with a mobile number to enable WhatsApp',
    'receipt.cash': 'CASH',
    'receipt.card': 'CARD',
    'receipt.upi': 'UPI',
    'receipt.khata': 'KHATA/CREDIT',
    'receipt.taxable_label': 'Taxable:',
    'receipt.gst_label': 'GST',
    'receipt.walk_in': 'Walk-in Customer',
  },
};
